import { ILineItem } from '~/lib/data-contract';
import { useFormattedPrice } from '~/shared/hooks/useFormattedPrice';
import { StyledLineItemPrice, StyledLineItemPriceContainer } from './styled';

export type LineItemPriceProps = Pick<ILineItem, 'discountedLinePrice' | 'linePrice' | 'discount'>;

export const LineItemPrice = ({ discountedLinePrice, linePrice, discount }: LineItemPriceProps) => {
	const formattedLinePrice = useFormattedPrice(linePrice, true);
	const formattedDiscountedLinePrice = useFormattedPrice(discountedLinePrice, true);
	const formattedSavings = useFormattedPrice(discount ? -discount : undefined, true);

	const isDiscounted = Boolean(discount);

	return (
		<StyledLineItemPriceContainer>
			{isDiscounted ? (
				<>
					<StyledLineItemPrice type="old">{formattedLinePrice}</StyledLineItemPrice>
					<StyledLineItemPrice type="saved">{formattedSavings}</StyledLineItemPrice>
					<StyledLineItemPrice type="actual">{formattedDiscountedLinePrice}</StyledLineItemPrice>
				</>
			) : (
				<>
					<StyledLineItemPrice type="actual">{formattedLinePrice}</StyledLineItemPrice>
				</>
			)}
		</StyledLineItemPriceContainer>
	);
};
